import { render, staticRenderFns } from "./FormOrganisationType.vue?vue&type=template&id=315f053a&scoped=true&"
import script from "./FormOrganisationType.vue?vue&type=script&lang=js&"
export * from "./FormOrganisationType.vue?vue&type=script&lang=js&"
import style0 from "./FormOrganisationType.vue?vue&type=style&index=0&id=315f053a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315f053a",
  null
  
)

export default component.exports